module.exports = __webpack_public_path__ + "img/数字经济产业园数字资源应用2.85b03432.png";